export default "__VITE_ASSET__adfcb96d__"